import { makeApi } from "@zodios/core";
import { z } from "zod";

import { missionDtoSchema } from "@/types/backoffice/dto/mission/mission-dto.ts";

export const backofficeOperationsApi = makeApi([
  {
    method: "get",
    path: "/missions",
    response: z.array(missionDtoSchema),
    alias: "findMissions",
  },
]);
